module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp2_8017.22593e80.png";